var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-ifp-filter',{attrs:{"label":"Spam","optionless":"","emphasize":"","removable":""},on:{"close-clicked":function($event){return _vm.handleCloseClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }